import { extendTheme } from "@chakra-ui/react";

export const theme = extendTheme({
  styles: {
    global: {
      body: {
        bg: "#E9E2DB",
        backgroundImage:
          "radial-gradient(ellipse 120% 80% at 85% 5%, rgba(106, 30, 30, 0.07) 0%, transparent 52%), radial-gradient(ellipse 100% 70% at 5% 95%, rgba(74, 15, 31, 0.06) 0%, transparent 48%), radial-gradient(ellipse 90% 60% at 50% 50%, rgba(216, 206, 195, 0.45) 0%, transparent 55%)",
        backgroundAttachment: "fixed",
      },
    },
  },
  colors: {
    transparent: "transparent",
    gradient_main_color:
      "linear-gradient(90deg, rgba(70,3,75,0.8522759445575105) 0%, rgba(60,175,191,1) 66%)",
    main_1:
      "linear-gradient( -145deg, rgb(253,200,48) 0%, rgb(243,115,53) 100%)",
    main_1_light: "#f7d7237d",
    main_2: "#f7d723",
    main_font: "#888f91",
  },

  fonts: {
    heading: "Baloo 2, cursive",
    body: "Baloo 2, cursive",
  },
});
